import 'assets/style/index.scss'
import Footer from 'components/Footer'
import { Footer as LaindingFooter } from 'components/Widgets/Landing'
import LoginModal from 'components/Widgets/LoginModal'
import React, { Suspense } from 'react'
import { ThemeProvider } from 'styled-components'
import { GlobalStyle } from './Global.style'
import {
  Container,
  Content,
  FooterContainer,
  HeaderContainer,
} from './Layout.style'
import { whiteOrange } from './theme'
import OrderModal from '../components/Widgets/OrderModal'
import Loader from 'components/Loader'
import Header from 'components/Header/Header'

const Layout = props => {
  const { layoutType, excludeFooter, excludeHeader } = props

  return (
    <ThemeProvider theme={whiteOrange}>
      <GlobalStyle />
      {layoutType !== 'landing' && !excludeHeader ? (
        <div className="app-main-container">
          {!excludeHeader ? (
            <HeaderContainer>
              <OrderModal />
              <Header />
            </HeaderContainer>
          ) : null}

          <Content>
            {layoutType === 'withoutContainer' ? (
              <Suspense
                fallback={<Loader notFull visible={true} type="ThreeDots" />}
              >
                {props.children}
              </Suspense>
            ) : (
              <Container id="content-container">
                <Suspense
                  fallback={<Loader notFull visible={true} type="ThreeDots" />}
                >
                  {props.children}
                </Suspense>
              </Container>
            )}
          </Content>
          {!excludeFooter ? (
            <FooterContainer>
              <Footer />
            </FooterContainer>
          ) : null}

          <LoginModal />
        </div>
      ) : (
        <Suspense fallback={<Loader notFull visible={true} type="ThreeDots" />}>
          {props.children}
          {excludeFooter ? null : <LaindingFooter />}
        </Suspense>
      )}
    </ThemeProvider>
  )
}

export default Layout
